import { commons } from './commons';
import { form } from './form';
import { notifications } from './notifications';
import { pages } from './pages';
import { popups } from './popups';

export const tr = {
  form,
  pages,
  popups,
  commons,
  notifications
};
